import {Component, EventEmitter, ViewChild, ElementRef} from '@angular/core';
import {ModalComponent} from '../modal-service.service';
import {FirmLogoModel} from '../../../models/firm-logo.model';
import {FileInfo} from '../../../models/attachment-file-info.model';
import { HttpClient } from '@angular/common/http';
import {AppConfigService} from '../../../../common/service/app-config.service';
import {concatMap, Observable} from 'rxjs';
import {XMLHTTP_REQUEST_READY_STATE, HTTP_STATUS_CODES} from '../../../constants';

@Component({
    selector: 'nlr-firm-logo-modal',
    imports: [],
    templateUrl: './firm-logo-modal.component.html',
    styleUrls: ['../modal.scss', './firm-logo-modal.component.scss']
})
export class FirmLogoModalComponent implements ModalComponent {
    @ViewChild('uploadFileInput') fileInput!: ElementRef<HTMLInputElement>;
    modalClosed: EventEmitter<FirmLogoModel | string> = new EventEmitter();

    modalSize: string = 'modal-md';
    title: string;
    firmlogoModel: FirmLogoModel;
    fileToUpload: File;
    fileInfo: FileInfo = {url: '', uuid: ''};

    constructor(
        private http: HttpClient,
        private appConfigService: AppConfigService
    ) {}

    clickFileInput() {
        if(this.fileInput){
            this.fileInput.nativeElement.click();
        }
    }

    uploadFileChange(files: File[]) {
        this.fileToUpload = files[0];
    }

    applyAndClose() {
        const url = this.appConfigService.settings.apiGatewayUrl + '/attachment/signedUrl/Logo/' + this.fileToUpload.name;
        this.uploadFile(url);
    }

    uploadFile(url: string) {
        const fileReader = new FileReader();

        fileReader.onload = () => {
            this.http
                .get<FileInfo>(url)
                .pipe(
                    concatMap(result => {
                        this.fileInfo.uuid = result.uuid;
                        const xhr = new XMLHttpRequest();
                        return new Observable(observer => {
                            xhr.onreadystatechange = () => {
                                if (xhr.readyState === XMLHTTP_REQUEST_READY_STATE.DONE) {
                                    if (xhr.status === HTTP_STATUS_CODES.OK) {
                                        observer.next(result);
                                        observer.complete();
                                    }
                                }
                            };
                            xhr.open('PUT', result.url, true);
                            xhr.setRequestHeader('Content-Type', 'application/octet-stream');
                            xhr.setRequestHeader('x-amz-server-side-encryption', 'AES256');
                            xhr.send(fileReader.result);
                        });
                    }),
                    concatMap(() => {
                        return this.getFirmLogoAttachmentData(this.fileInfo);
                    })
                )
                .subscribe(value => {
                    this.firmlogoModel = {
                        base64String: value,
                        fileLocation: this.fileInfo.uuid,
                        fileName: this.fileToUpload.name
                    } as FirmLogoModel;

                    this.modalClosed.emit(this.firmlogoModel);
                });
        };

        fileReader.readAsArrayBuffer(this.fileToUpload);
    }

    getFirmLogoAttachmentData(logo: FileInfo): Observable<string> {
        const url = this.appConfigService.settings.apiGatewayUrl + '/attachment/getFirmLogoAttachment';
        return this.http.post<string>(url, logo.uuid);
    }

    closeDialog() {
        this.modalClosed.emit('Close dialog');
    }
}
